module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11KTobg/tc-custom/9781504071239.jpg?1737676317355",
      "alt": "This image is the cover for the book Beware the Cuckoo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beware the Cuckoo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A reunion between childhood friends stirs up the traumas of the past—and poses a threat in the present . . . ")]), _c('br'), _c('br'), _vm._v("As a young, deeply insecure girl, Karen was targeted, and traumatized, by her friend Sandra’s father. Now, decades later, he is dead—and Karen has been reunited with Sandra, whom she hasn’t seen in ages. Against her better judgment, she agrees to meet Sandra at a nearby restaurant, and Sandra proves to be just as thoughtless and self-absorbed as she was back when the two of them and their friend Yvonne were attending school dances together."), _c('br'), _c('br'), _vm._v("Karen has a husband and children now, and they live in a beautiful home thanks to a successful family business. Sandra is supposed to be in town only temporarily, so Karen tolerates her excessive drinking and intrusive questions. But things become more difficult as her life starts to go awry—and as this taut, unsettling novel moves between past and present, secrets come to the surface and both women will come to understand the true cost of betrayal . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julie Newman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0